import { BitbucketGroup } from '@atlassian/cssxp-types-entitlement';
import { Results } from '@atlassian/cssxp-typescommon';

export const groupMembershipInitialState: any = {
  isSearching: false,
  error: null,
  results: [],
  totalHits: 0,
};
const SEARCH_GROUP_MEMBERSHIPS = 'SEARCH_GROUP_MEMBERSHIPS';
const SEARCH_MORE_GROUP_MEMBERSHIPS = 'SEARCH_MORE_GROUP_MEMBERSHIPS';
const SEARCH_GROUP_MEMBERSHIPS_FAILED = 'SEARCH_GROUP_MEMBERSHIPS_FAILED';

export const fetchInitialGroupMemberships = (data: Results<BitbucketGroup>) => ({
  type: SEARCH_GROUP_MEMBERSHIPS,
  data,
});

export const fetchGroupMembershipFailed = (error: Error) => ({
  type: SEARCH_GROUP_MEMBERSHIPS_FAILED,
  error,
});

export const fetchMoreGroupMembership = (data: Results<BitbucketGroup>) => {
  if (!data) return;

  return {
    type: SEARCH_MORE_GROUP_MEMBERSHIPS,
    data,
  };
};

export const groupMembershipReducer = (
  state: { results: any },
  action: { type: string; data?: Results<BitbucketGroup>; error?: Error } | undefined
) => {
  switch (action?.type) {
    case SEARCH_GROUP_MEMBERSHIPS:
      return action?.data;
    case SEARCH_MORE_GROUP_MEMBERSHIPS: {
      const results = action?.data?.results || [];
      if (results?.length > 0) {
        return {
          ...state,
          results: [...state.results, ...results],
        };
      }
      return state;
    }
    case SEARCH_GROUP_MEMBERSHIPS_FAILED: {
      return {
        ...state,
        error: action?.error,
      };
    }
    default:
      return state;
  }
};
